import { Investor, Unit, Property, Lessee, MonthlyCut } from './';

const classes = {
    'investor': Investor, 'unit': Unit, 'property': Property, 'lessee': Lessee,
    'monthlycut': MonthlyCut
};
export class ClassAccessor {
    static access(className: string) {
        if (classes.hasOwnProperty(className))
            return classes[className];
        return () => { return "Please import class"; }
    }
    static capitalize(text: string) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/accessor.ts